/**
 * 游客入园统计配置信息【限制每天只能提交一次个人信息，二次进入就直接展示，且提交时缓存之前的基础信息、姓名、身份证号等，后面填写时可不用再次填写】
 * 访问地址、后台入口（业务组件子系统--游客入园统计）
 * 邛海泸山【普通游客使用】：http://p.ued.daqsoft.com/scenic-register/#/sign-index?name=邛海泸山景区&resourceCode=C51340100394&maxPerson=3&isHasType=true
 * 邛海泸山【工作人员使用】：http://p.ued.daqsoft.com/register/qhls/#/special-person?name=邛海泸山景区&resourceCode=C51340100394&maxPerson=3&isHasType=true
 * 青都局：  http://project.daqsoft.com/register/qdj/#/sign-index?name=青城山-都江堰旅游景区管理局&subTitle=访客登记平台&resourceCode=10000051018100004&maxPerson=3
 * 地址参数说明：
 * @params {name}         入园名称（主标题，必填）
 * @params {subTitle}     副标题（选填，主标题过长时可考虑换行）
 * @params {resourceCode} 资源编码（据说是从文旅厅配置的）
 * @params {maxPerson}    最多填写人数
 * @params {isHasType}    是否展示景区入口选项
 * 需传主要参数如下，具体站点的配置信息可在README文件进行查找
 * @params {isSpecialPerson} 是否是特殊人员登记
 * @params {siteCode}        当前站点（必传）
 * @params {isHealthy}       是否展示健康码（必传）
 * @params {regionValue}     默认选中城市（必传）
 * @params {regionEntry}     景区出入口（必传）
 * */
const config = {
  default: 'https://www.xcqhls.cn/govapi/api/gov/app/',
  lang: 'cn',
  title: '入园登记',
  siteCode: 'qhlswgw',
  isHealthy: false, // 是否获取健康码
  regionValue: {
    // 默认选中的当前城市
    provinceName: '四川省',
    provinceRegin: '510000',
    provinceTouch: true,
    cityName: '凉山彝族自治州',
    cityRegin: '513400',
    cityTouch: true,
    areaName: '西昌市',
    areaRegin: '513401',
    areaTouch: true
  },
  regionEntry: [
    // 景区入口
    {
      name: '三期主入口',
      value: 1
    },
    {
      name: '泸山',
      value: 2
    },
    {
      name: '观鸟岛',
      value: 3
    },
    {
      name: '小渔村',
      value: 4
    },
    {
      name: '核桃村',
      value: 5
    },
    {
      name: '缸窑',
      value: 6
    },
    {
      name: '阳光学校',
      value: 7
    },
    {
      name: '凉大入口',
      value: 8
    },
    {
      name: '钓鱼台',
      value: 9
    },
    {
      name: '望海路',
      value: 10
    },
    {
      name: '观海桥',
      value: 11
    },
    {
      name: '联合入口',
      value: 12
    },
    {
      name: '小河人家',
      value: 13
    },
    {
      name: '古戏台',
      value: 14
    },
    {
      name: '迎宾路口',
      value: 15
    }
  ]
}

module.exports = config



// WEBPACK FOOTER //
// ./src/service/config.js